import React from 'react';
import { FaInstagram, FaLinkedin, FaYoutube, FaEnvelope } from 'react-icons/fa';
import './HeroSection.css';
import chiaraImage from '../assets/images/chiaraTr.png';

const HeroSection = () => (
  <section className="hero-section">
    <div className="hero-text-container">
      <h1 className="hero-title">Chiara Körner</h1>
      <div className="hero-container">
        <p className="hero-subtitle"><em>Mission Emotion</em></p>
        <p className="hero-body">
        Was, wenn deine Emotionen gar nicht das Problem sind, sondern der Zugang zur Antwort auf deine Fragen?<br></br>

Was wenn nicht Kontrolle das Ziel ist, sondern Verbindung, vertrauen und Selbstführung?<br></br><br></br><b>Deine Emotionen sind der Schlüssel – ich zeige dir, wie du ihn nutzt.</b>
      </p>
      </div>
      <div className="icon-container">
        <a href="https://www.instagram.com/chiarak_oerner/" className="icon-link" aria-label="Instagram"><FaInstagram /></a>
        
        <a href="https://www.youtube.com/@chiarakoerner" className="icon-link" aria-label="YouTube"><FaYoutube /></a>
        <a href="mailto:ckorner32@gmail.com" className="icon-link" aria-label="Email"><FaEnvelope /></a>
      
      </div>
    </div>
    <div className="hero-image-container">
      <img src={chiaraImage} alt="Chiara" className="hero-image" />
    </div>
  </section>
);

export default HeroSection;